const topicItems = [
  { tag: '科幻大片', count: '3.2万帖', hot: true },
  { tag: '悬疑烧脑', count: '2.8万帖', hot: true },
  { tag: '国产剧集', count: '4.1万帖', hot: true },
  { tag: '经典港片', count: '1.9万帖', hot: false },
  { tag: '韩剧推荐', count: '2.5万帖', hot: true },
  { tag: '4K修复', count: '1.2万帖', hot: false },
  { tag: '纪录片', count: '0.8万帖', hot: false },
  { tag: '动画电影', count: '1.6万帖', hot: true },
  { tag: '院线新片', count: '3.5万帖', hot: true },
  { tag: '日剧精选', count: '1.1万帖', hot: false },
  { tag: '影评讨论', count: '2.2万帖', hot: true },
];

const updateItems = [
  {
    date: '2026-08-01',
    title: '《星际迷航：新纪元》4K蓝光版正式上线',
    desc: '年度科幻巨制现已登陆90影视，支持4K HDR与杜比全景声，带来震撼视听体验。',
    tag: '新片上线',
  },
  {
    date: '2026-07-30',
    title: '暑期观影季活动火热进行中',
    desc: '精选100部高分影片限时开放蓝光画质，无需会员即可畅享家庭影院级视听体验。',
    tag: '平台活动',
  },
  {
    date: '2026-07-28',
    title: 'CDN节点全面升级，观影更流畅',
    desc: '新增东南亚及北美加速节点，海外用户观看体验大幅提升，缓冲等待成为过去式。',
    tag: '系统升级',
  },
  {
    date: '2026-07-25',
    title: '经典港片4K修复计划第三批上线',
    desc: '多部经典香港电影完成4K数字修复，画质焕然一新，重温黄金年代的银幕记忆。',
    tag: '经典修复',
  },
  {
    date: '2026-07-20',
    title: '纪录片频道改版，新增自然与人文专区',
    desc: '纪录片频道全新改版上线，按自然探索、人文历史、科技前沿三大主题分类呈现。',
    tag: '频道更新',
  },
  {
    date: '2026-07-15',
    title: '安卓客户端v3.2发布，支持投屏功能',
    desc: '新版本新增DLNA投屏与画中画播放，手机观影体验再升级，随时随地享受大屏乐趣。',
    tag: '版本更新',
  },
  {
    date: '2026-07-10',
    title: '用户反馈通道正式开放',
    desc: '欢迎大家通过投稿与合作通道反馈观影体验建议，帮助我们持续优化平台服务。',
    tag: '社区动态',
  },
];

export function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="bg-background-100/60 border border-background-200/40 rounded-lg p-6 md:p-10 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 text-center lg:text-left">
            <span className="text-xs font-label text-primary-400 uppercase tracking-wider">随时随地</span>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mt-1 mb-3">移动观影</h2>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md mx-auto lg:mx-0 mb-5">
              90影视适配手机、平板等多种移动设备，支持DLNA投屏与画中画播放。
              无论通勤路上还是睡前时光，高清超清画质随身携带，观影从未如此自由。
            </p>
            <div className="flex items-center justify-center lg:justify-start gap-3 flex-wrap">
              <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-label text-sm rounded-md transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-android-line"></i>
                Android 客户端
              </div>
              <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-200/70 hover:bg-background-300/70 text-foreground-700 font-label text-sm rounded-md border border-background-300/60 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-apple-line"></i>
                iOS 客户端
              </div>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative w-48 h-80 bg-background-50 border border-background-200/60 rounded-2xl overflow-hidden">
              <div className="absolute top-0 left-0 right-0 h-8 bg-background-100 flex items-center justify-center">
                <span className="text-[10px] text-foreground-500 font-label">90影视</span>
              </div>
              <div className="mt-8 p-3 space-y-2">
                <div className="h-28 bg-background-200/50 rounded-md flex items-center justify-center">
                  <i className="ri-play-circle-line text-3xl text-primary-400"></i>
                </div>
                <div className="h-2 bg-background-200/50 rounded w-3/4"></div>
                <div className="h-2 bg-background-200/50 rounded w-1/2"></div>
                <div className="h-2 bg-background-200/50 rounded w-2/3"></div>
                <div className="h-20 bg-background-200/50 rounded-md mt-2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100/40">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <span className="text-xs font-label text-accent-400 uppercase tracking-wider">社区热议</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mt-1">热门话题</h2>
        </div>
        <div className="flex flex-wrap gap-2 md:gap-3">
          {topicItems.map((item, i) => (
            <div
              key={i}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full cursor-pointer transition-colors whitespace-nowrap ${
                item.hot
                  ? 'bg-accent-500/10 text-accent-400 border border-accent-500/20 hover:bg-accent-500/20'
                  : 'bg-background-200/40 text-foreground-600 border border-background-200/60 hover:bg-background-300/40'
              }`}
            >
              <span className="text-sm font-label">{item.tag}</span>
              <span className="text-xs opacity-70 font-label">{item.count}</span>
              {item.hot && <i className="ri-fire-line text-xs"></i>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <span className="text-xs font-label text-primary-400 uppercase tracking-wider">平台动态</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mt-1">最新动态</h2>
        </div>
        <div className="relative pl-6 border-l-2 border-background-200/40 space-y-8">
          {updateItems.map((item, i) => (
            <div key={i} className="relative">
              <div className="absolute -left-[25px] top-1 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></div>
              <div className="flex items-center gap-2 mb-1 flex-wrap">
                <span className="text-xs text-foreground-500 font-label">{item.date}</span>
                <span className="px-2 py-0.5 text-[10px] font-label bg-primary-500/10 text-primary-400 rounded-full">{item.tag}</span>
              </div>
              <h3 className="text-sm text-foreground-950 font-label font-medium mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function AppTopicsGroup() {
  return (
    <>
      <AppSection />
      <TopicsSection />
      <UpdatesSection />
    </>
  );
}